import { NgModule } from '@angular/core';
import { Styling } from './styling';

@NgModule({
  providers: [Styling],
})
export class ContribStylingModule {}
